<template>
    <Alert v-if="alertContent || loadingMood" :loadingMood="loadingMood" :alertContent="alertContent" @close="alertContent=''"/>
    <div id="forget-password-container">
        <img src="../assets/appIcons/Pics/Flag.png" id="flag" alt="">
        <div class="row">
            <div class="col-lg-5">
                <div id="forget-password-container-form-content">
                    <form v-on:submit.prevent="handelSubmit">
                        <div id="title">فراموشی رمز عبور</div>
                        <div class="form-group">
                            <div class="input-group">
                                <span style="font-size: 14px;text-align: right;">  آدرس ایمیلی را که با آن ثبت نام کرده اید، وارد نمایید.</span>
                                <div class="text-field">
                                    <input id="email-input" name="email" v-model="data.email"  class="form-control" type="text" required>
                                    <label>ایمیل</label>
                                </div>
                            </div>
                        </div>
                        <button type="submit" style="display: none">submit</button>
                    </form>
                    <div>
                        <button type="submit"  v-on:click="handelSubmit" class="btn btn-success btn-block">ارسال ایمیل و بازیابی رمز عبور</button>
                        <div id="detail-txt">
                            تازه وارد هستید؟
                            <a v-on:click="$router.push('/user-signup')">
                                ثبت نام کنید.
                            </a>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-7 img-content">
                <div id="img-content"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import  Alert from '../components/Alert'
    import axios from 'axios'
    export default {
        name: "forget-password-container",
        components:{
            Alert,
        },
        data(){
            return {
                alertContent:null,
                loadingMood:false,
                data:{email:null}
            }
        },
        methods:{
            async handelSubmit() {
                try {
                    this.loadingMood=true;
                    let response = await axios.post('api/authentication/password/email' ,this.data);
                    this.loadingMood=false;
                    console.log(response);
                    localStorage.setItem('email',this.data.email);
                    this.alertContent={
                        message: 'ایمیلی حاوی لینک بازیابی رمز عبور برای شما ارسال شد!',
                        notice:'',
                        imageUrl:require('../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType:'close',//link
                        buttonText:'تایید',
                        buttonLink:'',///personal-info
                        waitingMode:false
                    };
                }catch (error) {
                    this.loadingMood=false;
                    this.alertContent={
                        message: 'خطا در انجام عملیات!',
                        notice:error.response.data.errors,
                        imageUrl:require('../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType:'close',
                        buttonText:'تایید',
                        closeButtonShow:true,
                        buttonLink:'',///personal-info
                        waitingMode:false
                    };
                }
            },
        }
    }
</script>

<style scoped>


    button:hover{
        background-color: #fe7063;
        border: none;
    }
    #detail-txt{
        width: 100%;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #162336;
    }
    #detail-txt>a{
        color: #162336;
        text-decoration: underline;
    }
    button{
        max-width: 305px;
        width: 100%;
        min-height: 50px;
        border-radius: 5px;
        background-color: #162336;
        margin: 0 0 10px;
        padding: 11px 41px;
        font-size: 16px;
    }

    form>.form-group{
        margin-top: 50px;
    }

    #email-input , #password-input{
        text-align: left;
    }

    .text-field {
        position: relative;
        margin: 30px 2.5px 20px 2.5px;
    }


    input:focus {
        border: thin solid #32cd32;
        border-bottom: solid medium #32cd32;
        background-color:#fff;
    }

    label {
        position: absolute;
        pointer-events: none;
        right: 10px;
        top: 5px;
        transition: 0.2s;
        text-align: right;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
        opacity: 1;
    }

    input:focus ~ label, input:valid ~ label {
        top: -12px;
        right: 15px;
        font-size: small;
        color:  #fe7063;
        padding:0 5px 0 5px;
        background-color: white;

    }



    input{
        text-align: right;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
        max-width: 300px;
        width: 100%;
        height: 40px;
        border-radius: 5px!important;
        opacity: 0.5;
        border: solid 0.5px #162336;
    }
    #title{
        font-size: 22px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
    }

    input:focus{
        border: solid 2px #fe7063!important;
    }
    *:focus {
        border: solid 0.5px #162336!important;
    }
    #forget-password-container-form-content{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        max-width: 370px;
        margin: auto;
        height: 518px;
        padding: 15px 30px 20px;
        border-radius: 10px;
        box-shadow: 0 0 12px 0 rgba(22, 35, 54, 0.2);
        background-color: #ffffff;
    }
    #forget-password-container-form-content>form{
        margin-top: 50px;
    }
    #flag{
        left: 0;
        top: 0;
        opacity: 0.05;
        height: 100%;
        width: 100%;
        position: absolute;
    }
    #img-content{
        width: 100%;
        height: 517px;
        margin: 35px auto;
        background-image: url("../assets/appIcons/Pics/Login.png");
        background-size: cover;
        background-repeat: no-repeat;
    }
    #forget-password-container{
        position: relative;
        height: auto;
        background-color: white;
        width: 100%;
        max-width: 970px;
        padding: 30px;
        margin: auto auto 50px auto;
        border-radius: 10px;
    }
    .text-field{
        width: 100%;
    }
    @media (max-width: 1000px) {
        .img-content{
            display: none;
        }
        #flag{
            display: none;
        }
        #forget-password-container{
            background-color: transparent;
        }
        .img-content{
            display: none;
        }
    }
</style>